import { useState } from 'react';

interface BrandMarkProps {
  compact?: boolean;
}

export function BrandMark({ compact = false }: BrandMarkProps): JSX.Element {
  const [hasImage, setHasImage] = useState(true);

  return (
    <div className={`brand-mark ${compact ? 'brand-mark--compact' : ''}`} aria-label="Forteens">
      {hasImage ? (
        <img
          className="brand-mark__image"
          src="/assets/logo-forteens.png"
          alt="Logo do Forteens"
          onError={() => setHasImage(false)}
        />
      ) : (
        <span className="brand-mark__fallback" aria-label="Forteens">
          <span>FOR</span><strong>TEENS</strong>
        </span>
      )}
    </div>
  );
}
